import { render, staticRenderFns } from "./bigCard.vue?vue&type=template&id=e670e8bc&scoped=true&"
import script from "./bigCard.vue?vue&type=script&lang=js&"
export * from "./bigCard.vue?vue&type=script&lang=js&"
import style0 from "./bigCard.vue?vue&type=style&index=0&id=e670e8bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e670e8bc",
  null
  
)

export default component.exports